import { gql } from '@apollo/client';
import { useGraphql } from 'utils/hooks/useGraphql';

export const verifiedContactCardFragment = gql`
  fragment VerifiedContactCardFragment on VerifiedContactCardDefinition {
    id
    createdAt
    updatedAt
    createdBy
    updatedBy
    isArchived
    displayName
    smsSender {
      id
      name
      phoneNumber
      type
    }
    website
    imageUrl
    subheader
    email
  }
`;

export const getVerifiedContactCardsByProjectIdQuery = gql`
  ${verifiedContactCardFragment}
  {
    getVerifiedContactCardsByProjectId {
      ...VerifiedContactCardFragment
    }
  }
`;

export function useQueryVerifiedContactCardByProjectId() {
  const { data, errorMessage, isLoading, refetch } = useGraphql(
    getVerifiedContactCardsByProjectIdQuery,
  );

  return {
    errorMessage: errorMessage?.message,
    isLoading,
    refetch,
    data: data?.getVerifiedContactCardsByProjectId,
  };
}
